import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {MatSort} from '@angular/material/sort';

import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';

import { Router } from '@angular/router';

import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import  firebase from 'firebase';

import { ToastrService } from 'ngx-toastr';
import imageCompression from 'browser-image-compression';

@Component({
  selector: 'app-pdf-library',
  templateUrl: './pdf-library.component.html',
  styleUrls: ['./pdf-library.component.css']
})
export class PdfLibraryComponent implements OnInit {
  spinner:boolean=false
  images0:boolean=false
  url00
  url0:string
  image_name
  image_title
  data_check:boolean=false
  time_now
  uploading_status:boolean=false
  uploadProgress0
  uploadProgress_0
  idColumn = 'key';
  pdf_data={date:0,pdf_url:null,pdf_name:null,pdf_title:null}
    /////////////////
  canceled="#f5365c"
  in_progress="#5e72e4"
  waiting="#ffea31"
  finished="#2dce89"
  user_info={a_id:null,uid:'',email:null,emailverified:'',f_name:'',l_name:'',date_birth:'',phone:null,company_name:'',skype_name:'',chiptuning_tool:'',user_name:'',address:'',city:'',country:'',postal_code:'',about:'',img_url:'',a1:'',a2:'',a3:0}

  customers=[]
  rows = 10;
  products1=[];
  filter=''
  ////
  displayedColumns: string[] = ['name' ,'uid' ,'date','btn']
 Ref_data = firebase.database().ref('pdflibrary')

    dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild('idtable') idtable: TemplateRef<any>;
  elementwindow=[]
  closeResult: string;
 
  constructor(private router: Router,private modalService: NgbModal,private toastr: ToastrService) {
    this.get_pdflibrary()
   }
  ngOnInit(): void {
    // throw new Error('Method not implemented.');
  }

  ngAfterViewInit(): void {
  
    // throw new Error('Method not implemented.');
    this.dataSource.paginator = this.paginator;
     
     this.dataSource.sort = this.sort;
    
   }
   onSelectFile00(event) {
    var imageFile=null
    this.image_name=null
    this.spinner=true
    this.url00=null
    this.url0=null
     imageFile = event.target.files[0];
    // console.log('originalFile instanceof Blob', imageFile instanceof Blob); // true
    // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

      this.image_name= Date.now()+imageFile.name
      this.pdf_data.pdf_name=Date.now()+imageFile.name
      this.url00= imageFile
 
  

     
  }
  file_url
  file_name
  file_size
  file:any
  uploading_pdf_status:boolean=false
  uploadProgress_pdf:number=0
  uploadProgress_pdfs:number=0
  init_file_2(event) {
    
  
    const element = event.target.files[0];
    this.file_size=element.size/1000 
    if(this.file_size < 1000){
      this.file_size = this.file_size + 'KB'
     }else{
      this.file_size =  this.file_size/1000 + 'MB'
     }
     ///
     if(element.name.includes(".pdf")  ) {
      
      this.file=element
      this.uploading_pdf_status=true
    }else{
      this.file=null
      this.file_name = null;
      this.toastr.warning('invalid_File_Format')
    }
    ///
  this.file_name=element.name
  if(element.size < 10024000){
     
    this.file=element
   
  }else{
    this.file=null
    this.toastr.warning('Max_file_size')
    this.file_name = "";
  }
  
  }
   open(content, type, modalDimension) {
    if (modalDimension === 'sm' && type === 'modal_mini') {
        this.modalService.open(content, { windowClass: 'modal-mini', size: 'sm', centered: true }).result.then((result) => {
            this.closeResult = 'Closed with: $result';
        }, (reason) => {
            this.closeResult = 'Dismissed $this.getDismissReason(reason)';
        });
    } else if (modalDimension === '' && type === 'Notification') {
      this.modalService.open(content, { windowClass: 'modal-danger', centered: true }).result.then((result) => {
          this.closeResult = 'Closed with: $result';
      }, (reason) => {
          this.closeResult = 'Dismissed $this.getDismissReason(reason)';
      });
    } else {
        this.modalService.open(content,{ centered: true }).result.then((result) => {
            this.closeResult = 'Closed with: $result';
        }, (reason) => {
            this.closeResult = 'Dismissed $this.getDismissReason(reason)';
        });
    }
  }

  private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
      } else {
          return  'with: $reason';
      }
  }


   applyFilter(event: Event) {
     const filterValue = (event.target as HTMLInputElement).value;
     this.dataSource.filter = filterValue.trim().toLowerCase();
 
     if (this.dataSource.paginator) {
       this.dataSource.paginator.firstPage();
     }
   }
   do_filter() {
    const filterValue = this.filter
    this.dataSource.filter = filterValue.trim().toLowerCase();
    console.log(filterValue)

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  add_new(){
    this.router.navigate(['admin/pdf-library/add'])
  }
pdflibrary_list=[]
get_pdflibrary(){

this.Ref_data.on('value',snapshots=>{
  this.pdflibrary_list=[]

  snapshots.forEach(snapshot=>{
let y = snapshot.val()
var date1 = new Date(y.date);
y.Date=  date1.toLocaleString()

y.key = snapshot.key
this.pdflibrary_list.push(y)
this.pdflibrary_list.sort(comparenameup)
this.dataSource = new MatTableDataSource(this.pdflibrary_list)
this.dataSource.sort = this.sort;
this.dataSource.paginator = this.paginator;
  })
})
// .then(()=>{
//   // this.pdflibrary_list.reverse()
//   this.pdflibrary_list.sort(comparenameup)
//   this.dataSource = new MatTableDataSource(this.pdflibrary_list)
//   this.dataSource.sort = this.sort;
//   this.dataSource.paginator = this.paginator;
// })
}



add_new_init(){

  let id = "add_photo_0"
  let go = document.getElementById(id)
  go.click()
  
}


upload(){
  if(this.url00 && this.pdf_data.pdf_title ){

  
  this.uploading_status=true
  this.time_now = Date.now()
  let storageRef = firebase.storage().ref('pdflibrary');
  var uploadTask = storageRef.child( this.pdf_data.pdf_title).put(this.url00)

 

  uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
  snapshot=> {
  // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
  this.uploadProgress0 = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
  this.uploadProgress_0= Math.floor(this.uploadProgress0)
  switch (snapshot.state) {
  case firebase.storage.TaskState.PAUSED: // or 'paused'
   this.toastr.warning('Upload is paused');
    break;
  case firebase.storage.TaskState.RUNNING: // or 'running'
  this.toastr.info('Upload is running');
    break;
  }
  }, (error=> {
  
  // A full list of error codes is available at
  // https://firebase.google.com/docs/storage/web/handle-errors
  switch (error.message) {
  case 'storage/unauthorized':
  // User doesn't have permission to access the object
  this.toastr.error("User doesn't have permission to access the object");
  break;
  
  case 'storage/canceled':
  // User canceled the upload
  this.toastr.error("User canceled the upload");

  break;
  
  
  
  case 'storage/unknown':
  // Unknown error occurred, inspect error.serverResponse
  this.toastr.error("Unknown error occurred, inspect error.serverResponse");

  break;
  }
  }), (()=> {
  // Upload completed successfully, now we can get the download URL
  uploadTask.snapshot.ref.getDownloadURL().then((downloadURL=> {
  
  this.pdf_data.pdf_url=downloadURL
  this.pdf_data.date=this.time_now
 
  
  
  ///let Ref = firebase.database().ref('users/'+this.user_info.a_id+'/orders/'); //old
  let Ref_data = firebase.database().ref('pdflibrary'); //new
  Ref_data.push(this.pdf_data).then(()=>{
    this.toastr.success('Upload finished, The photo added successfully. ')
    let id = "close_window"
    let go = document.getElementById(id)
    go.click()
    // this.pdflibrary_list.reverse()
    // this.pdflibrary_list.push(this.program_data)
    // this.dataSource = new MatTableDataSource(this.pdflibrary_list)
    // this.dataSource.sort = this.sort;
    // this.dataSource.paginator = this.paginator;
    this.pdf_data={date:0,pdf_url:null,pdf_name:null,pdf_title:null}
    this.url00=null
    this.url0=null
    this.uploading_status=false
  })
  
  // ).catch(error=>{
  //   console.log(error.message)
  // })
  
  }));
  }));
}else{
  this.toastr.error('You should input Photo and title')
  this.data_check=true

}
}


project_delete_data
  init_delete(event){
    let id = "delete_project_0"
    let go = document.getElementById(id)
    go.click()
    this.project_delete_data=event
  
  }

  go_delete(){
    // let ref = firebase.database().ref('acc').child('plans/'+this.project_delete_data.key)
    this.Ref_data.child(this.project_delete_data.key).remove().then(()=>{
     
    this.toastr.success('The project removed successfully')
    
    }).then(()=>{
      var desertRef = firebase.storage().ref('pdflibrary').child(this.project_delete_data.img_name)
      desertRef.delete().then(() => {
       
        let id = "close_window"
        let go = document.getElementById(id)
        go.click()
          this.get_pdflibrary()
        let dsData = this.dataSource.data;

        const itemIndex = dsData.findIndex(obj => obj[this.idColumn] === this.project_delete_data.key);
        this.dataSource.data.splice(itemIndex, 1);
        this.dataSource.paginator = this.paginator;
        this.project_delete_data=null

          this.toastr.success(' Deleted' )
      })
   
    })
  }

  copyToClipboard(event) {
    let url =event.pdf_url
    const elem = document.createElement('textarea');
    elem.value = url;
    document.body.appendChild(elem);
    elem.select();
    document.execCommand('copy');
    document.body.removeChild(elem);
    this.toastr.success(' The url of photo" '+ event.img_title+' " is copied' )
 }
}


export interface PeriodicElement {
  cid:number,vehicle_type:string,Make:string,Model:string,date:number,Engine:string,ECU:string,Credits:number, }
 export class ButtonOverviewExample {}
 const ELEMENT_DATA: PeriodicElement[] = [
  //  {    cid:1,vehicle_type:'car',Make:'bmw',Model:'m3',date:343432423,Engine:'ppr433e',ECU:'siemens',Credits:10},
 
];


function comparenameup(a, b) {
  const genreA = a.date;
  const genreB = b.date;

  let comparison = 0;
  if (genreA > genreB) {
    comparison = 1;
  } else if (genreA < genreB) {
    comparison = -1;
  }
  return comparison* -1;
}